import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  employeeLevelsAction,
  modalAction,
} from './../../actions/'
import {
  authSelector,
  employeeLevelsSelector,
  modalSelector,
} from './../../selectors'
import { searchLevels } from '../../function'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditEmployeeLevels from './edit'
import ListEmployeeLevels from './list'
import EmployeeLevelsForm from '../../components/employee-levels'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'

class EmployeeLevelsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      id: '',
      span: false,
      level_code: '',
      start_date: '',
      employeeLevel: '',
      search: '',
      defaultLevels: [],
      levels: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    this.props.getAuth(localStorage.getItem('access_token'))
  }

  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'employeeLevelsList') && this.state.search === '') {
      this.setState({
        levels: _.get(nextProps, 'employeeLevelsList'),
        defaultLevels: _.get(nextProps, 'employeeLevelsList'),
      })
    }
    if (_.get(nextProps, 'employeeLevelsCreate.employeeLevelsCreate')) {
      this.props.showModal(
        'employeeLevel',
        _.get(nextProps, 'employeeLevelsCreate.status'),
        _.get(nextProps, 'employeeLevelsCreate.message')
      )
      this.props.listEmployeeLevels(localStorage.getItem('access_token'))
      this.props.resetCreateEmployeeLevels()
    }
    if (_.get(nextProps, 'employeeLevelsEdit.employeeLevelsEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'employeeLevel',
        _.get(nextProps, 'employeeLevelsEdit.status'),
        _.get(nextProps, 'employeeLevelsEdit.message')
      )
      if (_.get(nextProps, 'employeeLevelsEdit.status') === 200) this.showSave()
      this.props.listEmployeeLevels(localStorage.getItem('access_token'))
      this.props.resetEditEmployeeLevels()
      this.handleClickEdit(false, '')
    }
    if (_.get(nextProps, 'employeeLevelsDeactivate.employeeLevelsDeactivate')) {
      this.props.showConfirm(
        'deleteLevel',
        _.get(nextProps, 'employeeLevelsDeactivate.status'),
        _.get(nextProps, 'employeeLevelsDeactivate.message')
      )
      this.props.listEmployeeLevels(localStorage.getItem('access_token'))
      this.props.resetDeactivateEmployeeLevels()
    }
    if (_.get(nextProps, 'exportURL')) {
      window.open(_.get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportEmployeeLevels()
    }
  }
  handleClickSearch() {
    this.setState({ levels: _.get(this.state, 'defaultLevels').filter(searchLevels, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ levels: _.get(this.state, 'defaultLevels'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editEmployeeLevel, employeeLevel_id) {
    this.setState({
      edit: editEmployeeLevel,
      id: employeeLevel_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your level information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('employeeLevelForm')
  }
  cancelForm() {
    this.props.hideModal('employeeLevelForm')
  }
  cancelAlert() {
    this.props.hideModal('employeeLevel')
  }
  submitForm() {
    this.props.createEmployeeLevels(
      {
        level_code: this.state.level_code,
        name: this.state.employeeLevel,
        start_date: new moment(this.state.start_date),
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetching')
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectEmployeeLevels.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    || get(this.props, 'redirectEmployeeLevels.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportEmployeeLevels(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          _.get(this.props, 'modalType') === 'employeeLevel' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ _.get(this.props, 'modalType') === 'employeeLevel' }
              type={ _.get(this.props, 'modalStatus') }
              message={ _.get(this.props, 'modalMessage') }
            />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'confirmSave' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          _.get(this.props, 'confirmType') === 'deleteLevel' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'deleteLevel' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListEmployeeLevels
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              levels={ this.state.levels }
              table={ 5 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditEmployeeLevels
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ _.get(this.props, 'confrimType') }
                confirmStatus={ _.get(this.props, 'confirmStatus') }
                confirmType={ _.get(this.props, 'confirmType') }
                confirmMessage={ _.get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ _.get(this.props, 'modalType') === 'employeeLevelForm' } toggle={ this.cancelForm }>
          <EmployeeLevelsForm
            create={ true }
            button={ button }
            confirm={ _.get(this.props, 'modalType') }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            level_code={ this.state.level_code }
            start_date={ this.state.start_date }
            employeeLevel={ this.state.employeeLevel }
            handleInput={ this.handleInput }
            cancelForm={ this.cancelForm }
            modalStatus={ _.get(this.props, 'modalStatus') }
            modalType={ _.get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

EmployeeLevelsPage.propTypes = {
  createEmployeeLevels: PropTypes.func.isRequired,
  resetCreateEmployeeLevels: PropTypes.func.isRequired,
  listEmployeeLevels: PropTypes.func.isRequired,
  resetDeactivateEmployeeLevels: PropTypes.func.isRequired,
  resetEditEmployeeLevels: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  getIsFetching: employeeLevelsSelector.getIsFetching,
  redirectAuth: authSelector.redirectAuth,
  redirectEmployeeLevels: employeeLevelsSelector.redirectEmployeeLevels,
  employeeLevelsCreate: employeeLevelsSelector.getCreateEmployeeLevelsData,
  employeeLevelsEdit: employeeLevelsSelector.getEditEmployeeLevelsData,
  employeeLevelsGet: employeeLevelsSelector.getGetEmployeeLevelsData,
  employeeLevelsDeactivate: employeeLevelsSelector.getDeactivateEmployeeLevelsData,
  employeeLevelsList: employeeLevelsSelector.getListEmployeeLevels,
  exportURL: employeeLevelsSelector.getExportURL,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuth,
  createEmployeeLevels: employeeLevelsAction.createEmployeeLevels,
  resetCreateEmployeeLevels: employeeLevelsAction.resetCreateEmployeeLevels,
  resetEditEmployeeLevels: employeeLevelsAction.resetEditEmployeeLevels,
  resetDeactivateEmployeeLevels: employeeLevelsAction.resetDeactivateEmployeeLevels,
  listEmployeeLevels: employeeLevelsAction.getEmployeeLevels,
  exportEmployeeLevels: employeeLevelsAction.exportEmployeeLevels,
  resetExportEmployeeLevels: employeeLevelsAction.resetExportEmployeeLevels,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(EmployeeLevelsPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/employee-levels/index.js